import { SnackbarState } from '../types';

export const snackbarStateDefaults: SnackbarState = {
  snackQueue: [],
};
